export default __webpack_public_path__ + "static/media/english-to-arabic-screenshot-02.1638b454.png";